import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";

const _hoisted_1 = /*#__PURE__*/_createTextVNode("Home");

const _hoisted_2 = /*#__PURE__*/_createTextVNode(" | ");

const _hoisted_3 = /*#__PURE__*/_createTextVNode("About");

const _hoisted_4 = /*#__PURE__*/_createTextVNode(" | ");

const _hoisted_5 = /*#__PURE__*/_createTextVNode("CompressPic");

const _hoisted_6 = /*#__PURE__*/_createTextVNode(" | ");

const _hoisted_7 = /*#__PURE__*/_createTextVNode("Web3");

const _hoisted_8 = /*#__PURE__*/_createTextVNode(" | ");

const _hoisted_9 = /*#__PURE__*/_createTextVNode("Tron");

export function render(_ctx, _cache) {
  const _component_router_link = _resolveComponent("router-link");

  const _component_router_view = _resolveComponent("router-view");

  return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("nav", null, [_createVNode(_component_router_link, {
    to: "/"
  }, {
    default: _withCtx(() => [_hoisted_1]),
    _: 1
  }), _hoisted_2, _createVNode(_component_router_link, {
    to: "/about"
  }, {
    default: _withCtx(() => [_hoisted_3]),
    _: 1
  }), _hoisted_4, _createVNode(_component_router_link, {
    to: "/cp"
  }, {
    default: _withCtx(() => [_hoisted_5]),
    _: 1
  }), _hoisted_6, _createVNode(_component_router_link, {
    to: "/web3"
  }, {
    default: _withCtx(() => [_hoisted_7]),
    _: 1
  }), _hoisted_8, _createVNode(_component_router_link, {
    to: "/tron"
  }, {
    default: _withCtx(() => [_hoisted_9]),
    _: 1
  })]), _createVNode(_component_router_view)], 64);
}